import React, { Fragment } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { COLORS } from "../../constants";
import MobileTradeSlideShow from "./MobileTradeSlideShow";
import RsvpForm from "./RsvpForm";

const MobileTradeShow = ({
  selectedYear,
  handleYearChange,
  control,
  errors,
  onSubmitClick,
  isRsvpModalOpen,
  onRsvpModalClose,
  createEventResponseCallStatus,
  setSelectedYear,
  imageUrls,
  isMobile,
  availableYears,
}) => {
  const getImageUrl = () =>
    `https://argusweb.azureedge.net/argus-web/home/hero-4${
      isMobile ? "-mobile" : ""
    }.jpg`;

  const renderRightSection = () => {
    if (selectedYear !== "2026") {
      return (
        <MobileTradeSlideShow
          selectedYear={selectedYear}
          imageUrls={imageUrls}
        />
      );
    }

    return (
      // <Box
      //   sx={{
      //     minHeight: "60vh",
      //     display: "flex",
      //     alignItems: "center",
      //     justifyContent: "center",
      //     backgroundColor: COLORS.white,
      //     py: 4,
      //   }}
      // >
      //   <img
      //     src="/comingSoonMobile.png"
      //     alt="Trade Show 2026 - Coming Soon"
      //     style={{
      //       width: "100%",
      //       maxWidth: "500px",
      //       height: "auto",
      //       objectFit: "contain",
      //     }}
      //   />
      // </Box>

      <RsvpForm
        control={control}
        errors={errors}
        onSubmitClick={onSubmitClick}
        isRsvpModalOpen={isRsvpModalOpen}
        onRsvpModalClose={onRsvpModalClose}
        createEventResponseCallStatus={createEventResponseCallStatus}
        setSelectedYear={setSelectedYear}
        isMobile
      />
    );
  };

  return (
    <Fragment>
      <Typography
        sx={{
          paddingLeft: 0,
          backgroundColor: "none",
          fontSize: isMobile ? "var(--font-size-l)" : "var(--font-size-xl)",
          fontWeight: 500,
          color: COLORS.darkText,
          my: 3,
        }}
      >
        Trade Show
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} md={3}>
          <Box
            sx={{
              borderRadius: "2px",
            }}
          >
            <Typography
              sx={{
                paddingLeft: 0,
                fontSize: "var(--font-size-l)",
                fontWeight: 500,
                lineHeight: "var(--spacing-xxl)",
                color: COLORS.darkText,
              }}
            >
              Argus Motoring Trade Show
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: COLORS.lightText,
                mb: 2,
                lineHeight: 1.8,
                mt: 1,
                fontSize: "var(--font-size-xxs)",
              }}
            >
              Argus Motor Company’s annual Trade Show in Brentwood Park
              highlights its extensive inventory of 30,000+ items, featuring
              DOE, BETA, and Argus Motoring brands. Industry professionals
              network with the team, discover new products, and witness live
              demos—upholding the company’s legacy of automotive excellence
              since 1955.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 2,
                mb: 4,
                width: "100%",
                overflowX: "auto",
                scrollSnapType: "x mandatory",
                "-webkit-overflow-scrolling": "touch",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                scrollbarWidth: "none",
              }}
            >
              {["2026", ...availableYears].map((year) => (
                <Button
                  key={year}
                  onClick={() => handleYearChange(year)}
                  sx={{
                    backgroundColor:
                      selectedYear === year ? COLORS.themeRed : COLORS.white,
                    borderRadius: "99px",
                    color: selectedYear === year ? COLORS.white : COLORS.gray,
                    border:
                      selectedYear === year
                        ? "none"
                        : `1px solid ${COLORS.border}`,
                    px: 4,
                    py: 1,
                    borderRadius: 3,
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{
                      textAlign: "center",
                      justifySelf: "center",
                      fontSize: "var(--font-size-xxs)",
                    }}
                  >
                    {year}
                  </Typography>
                </Button>
              ))}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          {renderRightSection()}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default MobileTradeShow;
